import type { BookingEventArgs } from "~/types/bookingEvents";

export const bookingDataLayerPush = (args: BookingEventArgs) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
};
